"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeCompositeChartJSONModelFromQueryString = exports.EventsPageModelProvider = exports.useEventsPageModelContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const CompositeChartJSONModel_1 = require("src/hello_assets/src/components/model/compositeChart/CompositeChartJSONModel");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const react_router_dom_1 = require("react-router-dom");
const query_string_1 = __importDefault(require("query-string"));
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const QueryEventVariantJSONModel_1 = require("src/hello_assets/src/components/model/common/queryEventVariant/QueryEventVariantJSONModel");
const STATE_QUERY_KEY = "state";
const EventsPageModelContext = React.createContext(undefined);
const useEventsPageModelContext = () => {
    const context = React.useContext(EventsPageModelContext);
    if (!context) {
        throw new Error("useEventsPageModelContext must be used within a EventsPageModelContext.Provider");
    }
    return context;
};
exports.useEventsPageModelContext = useEventsPageModelContext;
const EventsPageModelProvider = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [pageModelFormState, setPageModelFormState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), (0, exports.deserializeCompositeChartJSONModelFromQueryString)(location.search).serialize());
    ////////////////////////////////////////////////
    // Update page model on page URL change
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        if (isMounted()) {
            const compositeChartJSONModel = (0, exports.deserializeCompositeChartJSONModelFromQueryString)(location.search);
            if (!compositeChartJSONModel.getEventsJSONModel().hasItems()) {
                compositeChartJSONModel.getEventsJSONModel().addQueryEventVariantJSONModel(new QueryEventVariantJSONModel_1.QueryEventVariantJSONModel());
            }
            setPageModelFormState(compositeChartJSONModel.serialize());
        }
    }, [projectApiKey, location.search, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Get Form JSON Model
    ////////////////////////////////////////////////
    const getFormJSONModel = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        return new CompositeChartJSONModel_1.CompositeChartJSONModel(pageModelFormState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Period Changed
    ////////////////////////////////////////////////
    const onPeriodChanged = (0, use_custom_compare_1.useCustomCompareCallback)((last) => {
        const compositeChartJSONModel = new CompositeChartJSONModel_1.CompositeChartJSONModel(pageModelFormState);
        compositeChartJSONModel.getPeriodDaysJSONModel().setLast(last);
        const serializedState = compositeChartJSONModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Aggregation Changed
    ////////////////////////////////////////////////
    const onAggregationChanged = (0, use_custom_compare_1.useCustomCompareCallback)((aggregation) => {
        const compositeChartJSONModel = new CompositeChartJSONModel_1.CompositeChartJSONModel(pageModelFormState);
        compositeChartJSONModel.getCompositeChartAggregationJSONModel().setAggregation(aggregation);
        const serializedState = compositeChartJSONModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Events Changed
    ////////////////////////////////////////////////
    const onEventsChanged = (0, use_custom_compare_1.useCustomCompareCallback)((eventsSerializedState) => {
        const compositeChartJSONModel = new CompositeChartJSONModel_1.CompositeChartJSONModel(pageModelFormState);
        compositeChartJSONModel.getEventsJSONModel().overwriteFromSerializedState(eventsSerializedState);
        const serializedState = compositeChartJSONModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Show action
    ////////////////////////////////////////////////
    const show = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        if (isMounted()) {
            //model from location query
            const compositeChartJSONModelFromLocationQuery = (0, exports.deserializeCompositeChartJSONModelFromQueryString)(location.search);
            //passed model from UI
            const compositeChartJSONModel = new CompositeChartJSONModel_1.CompositeChartJSONModel(pageModelFormState);
            //compare if there are differences
            const isEqualState = lodash_1.default.isEqual(compositeChartJSONModelFromLocationQuery.serialize(), compositeChartJSONModel.serialize());
            //bump sequence to redraw UI
            compositeChartJSONModel.getSequenceJSONModel().bumpValue();
            const serializedState = CompositeChartJSONModel_1.CompositeChartJSONModel.makeModelStateClean(compositeChartJSONModel.serialize());
            //generate new URL
            const newUrl = AppRouting_1.AppPathGenerator.Project.events(projectApiKey, serializedState);
            if (isEqualState) {
                history.replace(newUrl);
            }
            else {
                history.push(newUrl);
            }
        }
    }, [projectApiKey, pageModelFormState, location.search, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Return value
    ////////////////////////////////////////////////
    const pageModelStateFns = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        getFormJSONModel: getFormJSONModel,
        show,
        onPeriodChanged: onPeriodChanged,
        onAggregationChanged: onAggregationChanged,
        onEventsChanged: onEventsChanged,
    }), [getFormJSONModel, show, onPeriodChanged, onAggregationChanged, onEventsChanged], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        pageModelFormState,
        pageModelStateFns,
    }), [
        pageModelFormState,
        pageModelStateFns,
    ], lodash_1.default.isEqual);
    return React.createElement(EventsPageModelContext.Provider, { value: value }, props.children);
};
exports.EventsPageModelProvider = EventsPageModelProvider;
const deserializeCompositeChartJSONModelFromQueryString = (query) => {
    const queryParams = query_string_1.default.parse(query);
    const modelStateSerialized = queryParams[STATE_QUERY_KEY];
    const jsonModel = new CompositeChartJSONModel_1.CompositeChartJSONModel();
    jsonModel.overwriteFromSerializedStateString(modelStateSerialized);
    return jsonModel;
};
exports.deserializeCompositeChartJSONModelFromQueryString = deserializeCompositeChartJSONModelFromQueryString;
